import { redirect } from 'react-router-dom';
import type { QueryClient } from '@tanstack/react-query';
import { signOut } from '@/services/auth/auth-service';
import { endAppSession } from '@/services/app-session/end-app-session';
import {
  APP_STATE_STORAGE_KEY,
  APP_STORAGE_KEY,
  REDEEM_STORAGE_KEY,
} from '@/components/AccessCodeRedemptionDialog/access-code-deep-link';

/**
 * The `/sign-out` route action. Ends the app session first so the call goes out
 * while the platform cookie is still valid, then awaits the platform logout
 * before redirecting.
 */
export async function signOutAction(queryClient: QueryClient) {
  await endAppSession({ reason: 'user' });

  sessionStorage.removeItem(REDEEM_STORAGE_KEY);
  sessionStorage.removeItem(APP_STORAGE_KEY);
  sessionStorage.removeItem(APP_STATE_STORAGE_KEY);

  try {
    await signOut();
    queryClient.clear();
  } catch (error) {
    console.error(error);
  }

  return redirect('/sign-in');
}
